import { useEffect, useRef } from 'react';
import type { MapRef } from 'react-map-gl';
import { regionCenters } from '@/data/locations/regionCenters';

interface MapboxRegionControllerProps {
  activeRegion: string;
  mapRef: React.RefObject<MapRef>;
}

export const MapboxRegionController = ({ activeRegion, mapRef }: MapboxRegionControllerProps) => {
  const prevRegionRef = useRef<string>(activeRegion);

  useEffect(() => {
    if (prevRegionRef.current === activeRegion) return;
    prevRegionRef.current = activeRegion;

    const map = mapRef.current?.getMap();
    if (!map) return;

    let center: [number, number];
    let zoom: number;

    if (activeRegion === 'all') {
      const config = regionCenters.all;
      // regionCenters stores [lat, lng], Mapbox needs [lng, lat]
      center = [config.center[1], config.center[0]];
      zoom = config.zoom;
    } else {
      const regionKey = activeRegion === 'Arar' ? "Ar'ar" : activeRegion;
      const config = regionCenters[regionKey as keyof typeof regionCenters];
      if (!config) return;
      center = [config.center[1], config.center[0]];
      zoom = config.zoom;
    }

    map.flyTo({
      center,
      zoom,
      pitch: 45,
      duration: 1500,
      essential: true,
    });
  }, [activeRegion, mapRef]);

  return null;
};
